<template>
  <div class="txn-page twod-bet">
      <div class="twod-bet-sticky__pad">
        <div class="txn-card twod-bet-toolbar">
          <div class="twod-bet-toolbar__head">
            <h1 class="twod-bet-toolbar__title">
              {{
                $store.state.language === 'en' ? '2D bet' : 'နှစ်လုံး ထီထိုး'
              }}
            </h1>
            <div class="twod-bet-toolbar__draw-group">
              <span class="twod-bet-toolbar__draw">{{
                $route.query.draw === 'm'
                  ? ($store.state.language === 'en' ? '12:01 draw' : '၁၂:၀၁ ထီ')
                  : ($store.state.language === 'en' ? '4:30 draw' : '၄:၃၀ ထီ')
              }}</span>
              <span class="twod-bet-toolbar__draw twod-bet-toolbar__draw--last">{{
                $store.state.language === 'en'
                  ? `Last: ${betClose()}`
                  : `နောက်ဆုံး: ${betClose()}`
              }}</span>
            </div>
          </div>
          <div class="txn-body twod-bet-toolbar__body">
            <div class="row no-gutters twod-bet-row twod-bet-row--split">
              <div class="col-4 pr-1">
                <button
                  type="button"
                  class="twod-bet-btn twod-bet-btn--secondary"
                  @click="showGroupBox"
                >
                  {{ $store.state.language === "en" ? "Quick bet" : "အမြန်ရွေးထိုးမည်" }}
                </button>
              </div>
              <div class="col-8 pl-1 twod-bet-amount-field">
                <!-- <label class="txn-label twod-bet-amount-field__label" for="twod-stake-input">{{
                  $store.state.language === "en" ? "Amount per number" : "နံပါတ်တစ်ခုချင်း ငွေပမာဏ"
                }}</label> -->
                <input
                  id="twod-stake-input"
                  ref="amount"
                  v-model="numberAmount"
                  type="number"
                  class="txn-input twod-bet-input"
                  :placeholder="$store.state.language === 'en' ? 'Min 100 MMK' : 'အနည်းဆုံး ၁၀၀ ကျပ်'"
                >
              </div>
            </div>

            <!-- <div class="twod-bet-meta">
              <div class="twod-bet-meta__item">
                <span class="twod-bet-meta__k">
                  <i class="fas fa-wallet twod-bet-meta__icon"></i>{{
                    $store.state.language === "en" ? "Balance" : "လက်ကျန်ငွေ"
                  }}
                </span>
                <span class="twod-bet-meta__v">{{
                  Number($store.state.amount).toLocaleString()
                }} {{ $store.state.language === "en" ? "MMK" : "ကျပ်" }}</span>
              </div>
              <div class="twod-bet-meta__item twod-bet-meta__item--end">
                <span class="twod-bet-meta__k">{{
                  $store.state.language === "en" ? "Bet closes" : "ထီပိတ်ချိန်"
                }}</span>
                <span class="twod-bet-meta__v">{{ betClose() }}</span>
              </div>
            </div> -->

            <div class="twod-bet-actions">
              <button
                type="button"
                class="twod-bet-chip twod-bet-chip--r"
                :class="{ 'twod-bet-chip--r-active': isReverse }"
                aria-label="Reverse"
                @click="isReverse = !isReverse"
              >
                R
              </button>
              <button
                type="button"
                class="twod-bet-btn twod-bet-btn--secondary twod-bet-actions__dream"
                @click="$router.push('/user/dream-books?type=2d')"
              >
                {{
                  $store.state.language === "en"
                    ? "Dream"
                    : "အိမ်မက်"
                }}
              </button>
              <button
                type="button"
                class="twod-bet-btn twod-bet-btn--primary"
                @click="preBet"
              >
                <span v-if="!isBet">{{
                  $store.state.language === "en"
                    ? "Bet"
                    : "ထိုးမည်"
                }}</span>
              </button>
            </div>

            <div class="twod-bet-footer">
              <button
                type="button"
                class="twod-bet-link"
                @click="openColorsModal()"
              >
                <span class="twod-bet-link__badge"><i class="fa fa-info"></i></span>
                <span>{{
                  $store.state.language === "en" ? "Color guide" : "အရောင်များ၏ အဓိပ္ပာယ်"
                }}</span>
              </button>
              <button
                type="button"
                class="twod-bet-link twod-bet-link--danger"
                @click="removeHistory()"
              >
                <i class="fa fa-redo twod-bet-link__icon"></i>
                <span>{{
                  $store.state.language === "en" ? "Clear all" : "အားလုံးရှင်း"
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    <div class="d-flex p-0 flex-wrap main-wrapper twod-bet-main justify-content-end">
      <div
        class="col-lg-4 col-md-6 col-12 px-1 mt--2 boxes"
        :class="!isGroup ? 'pb-5 mb-5' : ''"
      >
        <Table
          @numbers="getNumbers"
          :allNumbers="allNumbers"
          :isTwod="true"
          :on-my-event="myEventSource"
          :twod="twod"
        />
      </div>

      <div
        class="col-lg-4 col-md-6 col-12 d-flex flex-column px-2 boxes pb-5 mb-5"
        ref="groupBox"
      >
        <GroupBox
          @numbers="getGroupNumbers"
          :allNumbers="allNumbers"
          class="mt-2"
          :on-my-event="myEventSource"
          :drawTime="$route.query.draw === 'm' ? '12:00' : '4:30'"
        />
      </div>
    </div>

    <!-- Preview Voucher -->
    <div class="col-lg-4 col-md-6 px-2">
      <div class="row">
        <!-- === only amount === -->
        <div class="col-md-4 cart-voucher">
          <div
            class="modal fade"
            id="mobile-voucher"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-form"
            aria-hidden="true"
          >
            <div
              class="
                            modal-dialog
                            modal-
                            modal-dialog-centered
                            modal-sm
                        "
              role="document"
            >
              <div class="modal-content">
                <div
                  class="text-center modal-cross"
                  @click="closeModal"
                >
                  ×
                </div>
                <div class="modal-body p-0">
                  <PreviewVoucher
                    :remark="remark"
                    v-if="isMobile"
                    :datas="datas"
                    @remove="removeHistory"
                    :isTwod="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="col-lg-4 col-md-6 px-2">
      <div class="row">
        <!-- === only amount === -->
        <div class="col-md-4 cart-voucher">
          <div
            class="modal fade"
            id="colors-modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-form"
            aria-hidden="true"
          >
            <div
              class="
                                modal-dialog
                                modal-
                                modal-dialog-centered
                                modal-sm
                            "
              role="document"
            >
              <div class="modal-content twod-bet-modal twod-bet-modal--colors">
                <div class="twod-bet-colors-head">
                  <h4 class="twod-bet-colors-head__title">
                    <template v-if="$store.state.language === 'en'">
                      Color meaning<br>
                      <span class="twod-bet-colors-head__sub">At 100%, those numbers are closed.</span>
                    </template>
                    <template v-else>
                      အရောင် အဓိပ္ပါယ်<br>
                      <span class="twod-bet-colors-head__sub">၁၀၀% ဖြစ်သောအခါ ထီနံပါတ်များကို ပိတ်ပါမည်။</span>
                    </template>
                  </h4>
                </div>
                <div class="modal-body twod-bet-colors-body">
                  <ul class="twod-bet-colors-list">
                    <li class="twod-bet-colors-list__item">
                      <span class="twod-bet-dot twod-bet-dot--green"></span>
                      <span>{{
                        $store.state.language === 'en' ? 'Below 50%' : '၅၀% အောက်'
                      }}</span>
                    </li>
                    <li class="twod-bet-colors-list__item">
                      <span class="twod-bet-dot twod-bet-dot--yellow"></span>
                      <span>{{
                        $store.state.language === 'en' ? '50% – 75%' : '၅၀% မှ ၇၅% အတွင်း'
                      }}</span>
                    </li>
                    <li class="twod-bet-colors-list__item">
                      <span class="twod-bet-dot twod-bet-dot--red"></span>
                      <span>{{
                        $store.state.language === 'en' ? 'Above 90%' : '၉၀% အထက်'
                      }}</span>
                    </li>
                    <li class="twod-bet-colors-list__item">
                      <span class="twod-bet-dot twod-bet-dot--full"></span>
                      <span>{{
                        $store.state.language === 'en' ? 'Full (100%)' : 'အပြည့် (၁၀၀%)'
                      }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
import { newEventSource } from 'vue-parent-emit';
import { Sticky, Loading, Dialog, Toast } from 'vant';
import Table from '../../components/Table.vue';
import GroupBox from '../../components/GroupBox.vue';
import { mapActions } from 'vuex';
import PreviewVoucher from '../../components/PreviewVoucher.vue';

export default {
  components: {
    Table,
    GroupBox,
    // NormalBox,
    // NoticeBar,
    PreviewVoucher,
    Sticky,
    Loading,
  },
  data() {
    return {
      myEventSource: newEventSource(),
      datas: [],
      selected_data: {},
      isMobile: false,
      remark: '',
      isGroup: false,
      interval: false,
      noticeText: null,
      isBet: false,
      voucherId: this.slipId(),
      voucherLength: null,
      twod: {
        latest_bet_m: "11:45",
        latest_bet_e: "4:20",
      },
      betCloseTime: {},
      errors: {},
      numbers: [],
      numberAmount: null,
      allNumbers: this.$store.state.twod_numbers,
      isReverse: false,
    };
  },

  watch: {
    numberAmount: {
      handler() {
        this.datas = this.datas.map(item => ({
          ...item,          // Spread the existing properties of the object
          solo_amount: this.numberAmount  // Add or update the `solo_amount` property
        }));
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions(['fetchUser']),
    openColorsModal() {
      $('#colors-modal').modal('show');
    },
    setAmount(amount) {
      const currentHour = this.createDateWithTimeZone().getHours();
      const draw = currentHour < 12 ? '12:00' : '4:30';
      for (let i = 0; i < this.datas.length; i += 1) {
        this.datas[i].solo_amount = amount;
        this.datas[i].draw = draw;
      }
    },
    dialog(text) {
      Dialog.alert({
        message: text,
        confirmButtonText:
          this.$store.state.language === 'en'
            ? 'Go Back'
            : 'နောက်သို့ပြန်သွားမည်။',
      }).then(() => {
        // on close
      });
    },
    async twodData() {
      try {
        const res = await axios.get('2d/data');
        this.twod = res.data.data[0];
      } catch (error) {
        console.log(error);
      }
    },
    betClose() {
      if (this.$route.query.draw === 'm') {
        const newBetTimeArray = this.twod.latest_bet_m
          .toString(10)
          .split('')
          .map((t) => t);
        // console.log('newBetTimeArray',newBetTimeArray)
        this.betCloseTime.hour = newBetTimeArray[0].toString()
          + newBetTimeArray[1].toString();
        this.betCloseTime.minute = newBetTimeArray[3].toString()
          + newBetTimeArray[4].toString();
        this.betCloseTime.isMorning = true;
        return `${this.twod.latest_bet_m} AM`;
      }

      // if (currentDate > eveningDraw) {
      //   this.betCloseTime.isForTomorrow = true;
      // }

      const newBetTimeArray = this.twod.latest_bet_e
        .toString(10)
        .split('')
        .map((t) => t);
      this.betCloseTime.hour = parseInt(newBetTimeArray[0], 12) + 12;
      this.betCloseTime.minute = newBetTimeArray[2].toString() + newBetTimeArray[3].toString();
      return `${this.twod.latest_bet_e} PM`;
    },
    async checkCurrentVouchers() {
      try {
        const res = await axios.post('/vouchers/check', {
          type: 'twod',
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        this.voucherLength = res.data.voucherLength;
      } catch (error) {
        console.log(error);
      }
    },
    async preBet() {
      try {
        if (this.isBet) {
          return false;
        }
        if (this.voucherId === this.slipId()) {
          return false;
        }
        if (this.datas.length == 0) {
          const dataError = this.$store.state.language === "en"
            ? "Please pick some numbers!"
            : "နံပါတ်အချို့ ရွေးပေးပါ။";
          this.dialog(dataError);
          return false;
        }
        if (!this.numberAmount) {
          const dataError = this.$store.state.language === "en" ? 'Please enter amount' : 'ငွေပမာဏထည့်ပေးပါ။';
          this.dialog(dataError);
          return false;
        }
        if (this.numberAmount < 100) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'Please enter at least 100 MMK'
            : 'ငွေပမာဏအနည်းဆုံး ၁၀၀ ထည့်ပေးပါ။';

          const dataError = this.$store.state.language === "en" ? 'Please enter at least 100 MMK' : 'ငွေပမာဏအနည်းဆုံး ၁၀၀ ထည့်ပေးပါ။';
          this.dialog(dataError);
          return false;
        }

        if (this.isReverse) {
          // Step 1: Reverse numbers in selected data (`datas`)
          const reversedNumbers = this.datas.map(item => ({
            ...item,
            number: String(item.number).split('').reverse().join('') // Reverse the number
          }));

          // Step 2: Filter `allNumbers` based on reversed numbers
          const filteredFromAllNumbers = this.allNumbers.filter(item =>
            reversedNumbers.some(reversedItem => reversedItem.number == item.number)
          );

          // Step 3: Merge filtered data with selected data (`datas`)
          const combinedData = [
            ...this.datas,
            ...filteredFromAllNumbers
          ];

          // Step 4: Remove duplicates based on `number`
          this.datas = combinedData.reduce((acc, current) => {
            const x = acc.find(item => item.number == current.number);
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
          }, []);

          let draw = '4:30';
          if (this.$route.query.draw === 'm') {
            draw = '12:00';
          }
          this.datas = this.datas.map(item => ({
            ...item,          // Spread the existing properties of the object
            solo_amount: this.numberAmount,  // Add or update the `solo_amount` property
            draw: draw
          }));
        }

        $("#mobile-voucher").modal("show");
      } catch (error) {
        console.log(error);
      }
    },

    slipId() {
      return this.voucherLength;
    },
    /* eslint-disable */
    async finalBet() {
      this.setAmount(this.numberAmount);
      const userRes = await this.$auth.fetch();
      this.voucherId = this.slipId();
      this.$store.commit("setAmount", userRes.data.data.amount);
      this.isBet = true;
      this.betClose();
      const currentDate = this.createDateWithTimeZone();
      const newDate = this.createDateWithTimeZone();
      // if (this.isTwod) {
      newDate.setHours(
        parseInt(this.betCloseTime.hour, 10),
        parseInt(this.betCloseTime.minute, 10),
        0
      );
      try {
        if (this.datas.length > 0) {
          this.newRemark = JSON.parse(JSON.stringify(this.remark));
          if (this.twod.isOpen && !this.betCloseTime.isForTomorrow && currentDate > newDate) {
            const dataError =
              this.$store.state.language === "en"
                ? "Bet Close Now! Today may be holiday or Temporary closed for now!"
                : "အခုထိုးလို့မရသေးပါ။ ပိတ်ထားပါသည်။ ( ပိတ်ရက် ဒါမှမဟုတ် ယာယီပိတ်ထားခြင်း ဖြစ်နိုင်ပါသည်။ )";
            this.dialog(dataError);
            this.isBet = false;
            this.voucherId = null;
            return false;
          }
          for (let i = 0; i < this.datas.length; i += 1) {
            this.datas[i].bet_date = this.currentTime();
          }
          if (
            this.$store.state.amount >= this.totalAmount() ||
            this.type === "admin"
          ) {
            const res = await axios.post("/vouchers", {
              datas: this.datas,
              voucherId: this.voucherId,
              betTime: this.currentTime(),
              isTwod: true,
              remark: this.remark,
              draw_date: null,
            });
            this.checkCurrentVouchers();
            if (res.data.message) {
              this.dialog(
                this.$store.state.language === "en"
                  ? "Bet Close Now! Today may be holiday or Temporary closed for now!"
                  : "အခုထိုးလို့မရသေးပါ။ ပိတ်ထားပါသည်။ ( ပိတ်ရက် ဒါမှမဟုတ် ယာယီပိတ်ထားခြင်း ဖြစ်နိုင်ပါသည်။ )"
              );
            } else {
              if (res.data.overLimitNumbers.length > 0) {
                const dataError = `${this.$store.state.language === "en"
                    ? "Limited number amount"
                    : "ကန့်သတ်ထားသောနံပါတ်နှင့် ငွေပမာဏ"
                  } : ${JSON.stringify(res.data.overLimitNumbers)
                    .replace(
                      /[`~!@#$%^&*()_|+\-=?;'".<>\{\[\]\/]/gi,
                      ""
                    )
                    .replace(/[\}\\\/]/g, ", ")
                    .toString()
                    .bold()
                    .fontsize(4)}`;
                this.dialog(dataError);
                this.removeClosedNumbers(
                  res.data.closedNumbers,
                  res.data.overLimitNumbers
                );
              } else {
                this.removeClosedNumbers(
                  res.data.closedNumbers
                );
              }

              if (this.type !== "admin") {
                this.$store.commit(
                  "setAmount",
                  (this.$store.state.amount -=
                    this.totalAmount())
                );
                await this.$auth.fetch();
              }

              // $('#mobile-voucher').modal('hide');
              if (res.data.closedNumbers.length > 0) {
                const dataError = `${this.$store.state.language === "en"
                    ? "Closed number(s)"
                    : "ပိတ်ထားသော နံပါတ်များ"
                  } : ${res.data.closedNumbers
                    .toString()
                    .bold()
                    .fontsize(4)}`;
                this.dialog(dataError);
              }

              this.removeHistory();
              this.remark = null;
              Toast.success(
                this.$store.state.language === 'en'
                  ? 'Success!'
                  : 'အောင်မြင်သည်။',
              );
            }
          } else {
            const balanceError =
              this.$store.state.language === "en"
                ? "You Don't Have Sufficient Balance"
                : "အကောင့်ထဲတွင် ပိုက်ဆံအလုံအလောက် မရှိပါ။";
            this.dialog(balanceError);
          }
        } else {
          const dataError =
            this.$store.state.language === "en"
              ? "Please pick some numbers!"
              : "နံပါတ်အချို့ ရွေးပေးပါ။";
          this.dialog(dataError);
        }
        this.isBet = false;
        this.voucherId = null;
      } catch (error) {
        console.log(error);
        this.isBet = false;
        this.voucherId = null;
      }
      return true;
    },
    changeOverLimitedNumberAmount(list) {
      for (let i = 0; i < list.length; i += 1) {
        const index = this.datas.findIndex(
          (data) => data.number === list[i].number,
        );
        this.datas[index].solo_amount = list[i].amount;
        console.log(this.datas);
      }
    },
    removeClosedNumbers(list, limitedAmounts = null) {
      if (limitedAmounts) {
        this.changeOverLimitedNumberAmount(limitedAmounts);
      }
      for (let i = 0; i < list.length; i += 1) {
        const index = this.datas.findIndex(
          (data) => data.number === list[i],
        );
        console.log(index);
        this.datas.splice(index, 1);
      }
      $('#voucher').modal('show');
    },

    currentTime() {
      return moment(this.createDateWithTimeZone()).format("lll");
    },
    totalAmount() {
      let total = 0;
      for (let i = 0; i < this.datas.length; i += 1) {
        total += parseInt(this.datas[i].solo_amount, 10);
      }
      if (this.$auth.check("comissioner")) {
        const comissionerValue =
          total *
          (this.$auth.user()["2d_comission"] / 100);
        total -= comissionerValue;
      }
      return total;
    },

    createDateWithTimeZone() {
      const moment = require('moment-timezone');
      const dateInTimeZone = moment.tz(new Date(), 'Asia/Rangoon');
      // Extract individual components from moment object
      const year = dateInTimeZone.year();
      const month = dateInTimeZone.month();
      const day = dateInTimeZone.date();
      const hour = dateInTimeZone.hour();
      const minute = dateInTimeZone.minute();
      const second = dateInTimeZone.second();
      const millisecond = dateInTimeZone.millisecond();

      // Create a new Date object with the extracted components
      const newDateObject = new Date(year, month, day, hour, minute, second, millisecond);
      return newDateObject;
    },

    drawOptionGenerator() {
      const currentTime = this.createDateWithTimeZone();

      const evening = this.createDateWithTimeZone();
      evening.setHours(16, 25);

      if (currentTime > evening) {
        this.noticeText = this.$store.state.language === 'en' ? '2D is closed for Today.' : 'ယနေ့အတွက် နှလုံးထီ ထိုးခြင်း ပိတ်ပါပြီ ။';
        return true;
      }
      return false;
    },

    showGroupBox() {
      this.isGroup = !this.isGroup;
      $('#2d_group_box').modal('show');
    },
    sendEvent() {
      this.myEventSource.emit();
    },
    closeModal() {
      $('#mobile-voucher').modal('hide');
      $('#colors-modal').modal('hide');
    },
    getRemark(value) {
      this.remark = value;
    },
    getNumbers(value) {
      for (let i = 0; i < this.allNumbers.length; i += 1) {
        if (value.findIndex(obj => obj.number === this.allNumbers[i].number) >= 0) {
          this.allNumbers[i].isSelect = true;
        } else {
          this.allNumbers[i].isSelect = false;
        }
      }
      this.datas = value;
      let draw = '4:30';
      if (this.$route.query.draw === 'm') {
        draw = '12:00';
      }
      this.datas = this.datas.map(item => ({
        ...item,          // Spread the existing properties of the object
        solo_amount: this.numberAmount, // Add or update the `solo_amount` property
        draw: draw
      }));
    },
    getGroupNumbers(value) {
      for (let i = 0; i < this.allNumbers.length; i += 1) {
        this.allNumbers[i].isSelect = false;
      }
      for (let i = 0; i < value.length; i += 1) {
        this.allNumbers[this.allNumbers.findIndex(obj => obj.number === value[i].number)].isSelect = value[i].isSelect;
      }
      this.datas = value;
      let draw = '4:30';
      if (this.$route.query.draw === 'm') {
        draw = '12:00';
      }
      this.datas = this.datas.map(item => ({
        ...item,          // Spread the existing properties of the object
        solo_amount: this.numberAmount, // Add or update the `solo_amount` property
        draw: draw
      }));
    },
    removeHistory() {
      this.datas = [];
      $("#mobile-voucher").modal("hide");
      this.numberAmount = null;
      // this.sendEvent();
      this.sendEvent();
      this.allNumbers = this.allNumbers.map(item => ({
        ...item,
        isSelect: false
      }));
    },
    async fetchTwoNumbers() {
      try {
        const res = await axios.post('/twod_numbers', {
          limit: 'all',
          draw: this.$route.query.draw === 'm' ? '12:00' : '4:30',
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        this.allNumbers = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  destroyed() {
    clearInterval(this.interval);
  },
  unmounted() {
    clearInterval(this.interval);
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    this.$store.commit(
      'setAmount',
      parseInt(authUser.amount, 10),
    );

    this.fetchTwoNumbers();
    this.checkCurrentVouchers();
    this.twodData();

    this.interval = setInterval(() => this.drawOptionGenerator(), 3000);

    if (window.innerWidth < 768) {
      this.isMobile = true;
    }



    // if (this.$auth.check()) {
    //   this.$store.commit(
    //     'setAmount',
    //     parseInt(this.$auth.user().amount, 10),
    //   );
    // }
  },
};
</script>
<style scoped>
/* Page — match Deposit / Withdraw */
.txn-page {
  min-height: 100vh;
  padding: 0 0 1rem;
  padding-bottom: calc(1rem + env(safe-area-inset-bottom, 0px));
  background-color: #0d0e12;
  background-image: linear-gradient(180deg, rgba(13, 14, 18, 0.92) 0%, rgba(13, 14, 18, 0.88) 100%),
    url('https://storage.googleapis.com/spacetech2/mdl/bg.png');
  background-size: cover;
  background-position: center top;
  background-attachment: scroll;
  -webkit-overflow-scrolling: touch;
}

.twod-bet-sticky__pad {
  padding: 0.45rem 0.6rem 0;
}

.txn-card {
  background: #1d1f26;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
  margin-bottom: 0.65rem;
  overflow: hidden;
}

.twod-bet-toolbar.txn-card {
  background: #181a21;
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: 12px;
  box-shadow:
    0 4px 24px rgba(0, 0, 0, 0.45),
    0 0 0 1px rgba(0, 0, 0, 0.35) inset;
  margin-bottom: 0.45rem;
}

.twod-bet-toolbar__head {
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  display: flex;
  justify-content: space-between;
  padding: 0.45rem 0.75rem 0.4rem;
}

.twod-bet-toolbar__title {
  color: #e8eaef;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1.2;
  margin: 0;
  text-transform: uppercase;
}

.twod-bet-toolbar__draw-group {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 0.35rem;
  justify-content: flex-end;
  white-space: nowrap;
}

.twod-bet-toolbar__draw {
  background: rgba(92, 152, 255, 0.15);
  border: 1px solid rgba(92, 152, 255, 0.35);
  border-radius: 999px;
  color: #b8d0ff;
  font-size: 0.625rem;
  font-weight: 700;
  line-height: 1.2;
  padding: 0.25rem 0.5rem;
  text-transform: uppercase;
}

.twod-bet-toolbar__draw--last {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.12);
  color: #96a0b8;
  text-transform: none;
}

.twod-bet-toolbar__body {
  padding: 0.4rem 0.75rem 0.5rem;
}

.twod-bet-toolbar .txn-label {
  color: #8b95a8;
  display: block;
  font-size: 0.6875rem;
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 0.2rem;
}

.twod-bet-toolbar .txn-input {
  background: #252830 !important;
  border: none !important;
  border-radius: 10px !important;
  box-shadow: none !important;
  color: #f0f2f5 !important;
  font-size: 0.9375rem !important;
  line-height: 1.25 !important;
  min-height: 2.35rem;
  padding: 0.45rem 0.65rem !important;
  width: 100%;
}

.twod-bet-toolbar .txn-input:focus {
  box-shadow: 0 0 0 2px rgba(92, 152, 255, 0.45) !important;
  outline: none !important;
}

.twod-bet-toolbar .txn-input::placeholder {
  color: #5c6478;
}

/* Make amount field visually obvious as input area */
.twod-bet-toolbar .twod-bet-input {
  background: #2d3140 !important;
  border: 1px solid rgba(106, 159, 255, 0.55) !important;
  box-shadow: 0 0 0 1px rgba(106, 159, 255, 0.18) inset !important;
}

.twod-bet-toolbar .twod-bet-input::placeholder {
  color: #94a3c7;
  font-weight: 600;
}

.twod-bet-toolbar .twod-bet-input:focus {
  background: #323748 !important;
  border-color: rgba(106, 159, 255, 0.85) !important;
  box-shadow:
    0 0 0 2px rgba(106, 159, 255, 0.45),
    0 0 14px rgba(106, 159, 255, 0.2) !important;
}

.twod-bet-row--split {
  align-items: flex-end;
  margin-bottom: 0.55rem;
}

.twod-bet-row--split .col-6 {
  max-width: 50%;
}

.twod-bet-amount-field__label {
  margin-bottom: 0.2rem;
}

.twod-bet-btn {
  -webkit-tap-highlight-color: transparent;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.75rem;
  font-weight: 600;
  min-height: 2.35rem;
  padding: 0.35rem 0.5rem;
  transition: filter 0.15s ease, background 0.15s ease;
}

.twod-bet-btn--secondary {
  align-self: end;
  background: #252830;
  color: #e8eaef;
}

.twod-bet-btn--secondary:active {
  filter: brightness(1.08);
}

.twod-bet-btn--primary {
  align-self: stretch;
  background: linear-gradient(180deg, #6a9fff 0%, #5c98ff 100%);
  color: #fff;
  flex: 1;
  font-size: 0.875rem;
  min-height: 2.35rem;
}

.twod-bet-btn--primary:active {
  filter: brightness(1.05);
}

.twod-bet-meta {
  background: #22252e;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  justify-content: space-between;
  margin-bottom: 0.55rem;
  padding: 0.45rem 0.6rem;
}

.twod-bet-meta__item {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
}

.twod-bet-meta__item--end {
  align-items: flex-end;
  text-align: right;
}

.twod-bet-meta__k {
  color: #8b95a8;
  font-size: 0.625rem;
  font-weight: 600;
  line-height: 1.2;
  text-transform: uppercase;
}

.twod-bet-meta__icon {
  color: #6a9fff;
  margin-right: 0.25rem;
}

.twod-bet-meta__v {
  color: #f0f2f5;
  font-size: 0.8125rem;
  font-weight: 700;
  line-height: 1.2;
}

.twod-bet-actions {
  align-items: stretch;
  display: flex;
  gap: 0.4rem;
  margin-bottom: 0.45rem;
}

.twod-bet-chip {
  -webkit-tap-highlight-color: transparent;
  align-items: center;
  background: #252830;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  color: #c5cad6;
  cursor: pointer;
  display: flex;
  flex: 0 0 2.35rem;
  font-size: 0.9rem;
  font-weight: 800;
  justify-content: center;
  min-height: 2.35rem;
  padding: 0;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.twod-bet-chip--r-active {
  background: rgba(92, 152, 255, 0.22);
  border-color: rgba(92, 152, 255, 0.5);
  color: #fff;
}

.twod-bet-actions__dream {
  flex: 0 0 auto;
  min-width: 4.5rem;
  white-space: nowrap;
}

.twod-bet-footer {
  align-items: center;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  justify-content: space-between;
  padding-top: 0.4rem;
}

.twod-bet-link {
  -webkit-tap-highlight-color: transparent;
  align-items: center;
  background: transparent;
  border: none;
  color: #8ab4ff;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.75rem;
  font-weight: 600;
  gap: 0.3rem;
  line-height: 1.2;
  padding: 0.15rem 0;
}

.twod-bet-link--danger {
  color: #ff8a95;
}

.twod-bet-link__badge {
  align-items: center;
  background: rgba(92, 152, 255, 0.2);
  border-radius: 6px;
  color: #b8d0ff;
  display: inline-flex;
  font-size: 0.6rem;
  height: 1.3rem;
  justify-content: center;
  width: 1.3rem;
}

.twod-bet-link__icon {
  font-size: 0.85rem;
}

.twod-bet-main {
  padding: 0 0.35rem 4rem;
}

/* Modals */
.modal-cross {
  align-items: center;
  background: rgba(255, 107, 122, 0.95);
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 1.1rem;
  font-weight: 700;
  height: 2rem;
  justify-content: center;
  line-height: 1;
  margin: -0.35rem -0.35rem 0 auto;
  width: 2rem;
  z-index: 2;
}

::v-deep #mobile-voucher .modal-content.twod-bet-modal,
::v-deep #colors-modal .modal-content.twod-bet-modal {
  background: #1d1f26;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.5);
  overflow: hidden;
}

.twod-bet-modal__body {
  padding: 0.5rem 0.75rem 1rem !important;
}

.twod-bet-colors-head {
  background: #252830;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  padding: 1rem 1.1rem;
}

.twod-bet-colors-head__title {
  color: #e8eaef;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.45;
  margin: 0;
  text-align: center;
}

.twod-bet-colors-head__sub {
  color: #8b95a8;
  display: block;
  font-size: 0.78rem;
  font-weight: 600;
  margin-top: 0.35rem;
}

.twod-bet-colors-body {
  padding: 1rem 1.25rem 1.25rem !important;
}

.twod-bet-colors-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.twod-bet-colors-list__item {
  align-items: center;
  color: #e8eaef;
  display: flex;
  font-size: 0.875rem;
  font-weight: 500;
  gap: 0.65rem;
  margin-bottom: 0.85rem;
}

.twod-bet-colors-list__item:last-child {
  margin-bottom: 0;
}

.twod-bet-dot {
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  flex-shrink: 0;
  height: 1.15rem;
  width: 1.15rem;
}

.twod-bet-dot--green {
  background: #2d8a54;
}

.twod-bet-dot--yellow {
  background: #c9a227;
}

.twod-bet-dot--red {
  background: #c43d3d;
}

.twod-bet-dot--full {
  background: #5c6478;
}

.input-group {
  border: 1px solid #cccccc;
}

@media (max-width: 768px) {
  .boxes {
    margin-bottom: 7px;
    margin-top: 6px;
  }

  .main-wrapper {
    padding: 0 !important;
  }

  .preview-box {
    display: none;
  }

  .twod-bet-btn--secondary {
    min-height: 2.35rem;
    width: 100%;
  }

  .twod-bet-actions__dream {
    flex: 1;
    min-width: 0;
  }
}

@media (min-width: 769px) {
  .twod-bet-sticky__pad {
    max-width: 720px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
